<template>
    <div class="a-infoMessage">
        <img
            class="a-infoMessage-img"
            src="/img/icons/ep/contact-mail.png"
            alt
        />
        <h5 class="a-infoMessage-text">
            <span v-html="text"></span>
        </h5>
        <the-btn
            v-if="btnText || btnIcon"
            @click.native="$emit('click')"
            class="a-infoMessage-btn btn-sm btn-secondary"
            ><a-icon :icon="btnIcon" class="mr-1" />{{ btnText }}</the-btn
        >
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: false
        },
        btnText: {
            type: String,
            required: false
        },
        btnIcon: {
            type: String,
            required: false
        }
    }
}
</script>
